import { Grid, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import './ContactsPage.css';
import { useOutletContext } from 'react-router-dom';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/AlternateEmail';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TelegramIcon from '@mui/icons-material/Telegram';

export default function ContactsPage({setToken}) {
  const [firstTime, setFirstTime] = useState(true);
  const [isMobile, loading] = useOutletContext();

  useEffect(() => {
    if(firstTime)
    {
      
    }
    setFirstTime(false);
  }, [firstTime]);

  return (
    <>
        <Stack alignContent={"center"} style={{padding: "0 2rem", width: isMobile ? "100%" : "85%", margin: "auto"}}>
            <div style={{textAlign: "center" }}>
              <h2><b>CONTATTI</b></h2>
            </div><br/>
            <Grid container spacing={8}>
              <Grid item xs={12} sm={12} md={6} lg={7}>
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2780.4429610483867!2d10.528115999999999!3d45.822413299999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47822f68e97c863d%3A0xec717315153a1f!2sCinema%20Aurora!5e0!3m2!1sit!2sit!4v1686819573097!5m2!1sit!2sit" 
                  title="map"
                  width="100%"
                  style={{border: "1px solid #e8e8e8", height: isMobile ? "20rem" : "40rem", marginBottom: "0"}}
                  allowFullScreen="" loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade">
                </iframe>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={5}>
                Il Cinema Aurora si trova in <b>Via Caduti 63, 25072 Ponte Caffaro (BS)</b>.<br/><br/>
                Per maggiori <b>informazioni o richieste particolari</b> potete contattarci presso i seguenti numeri di telefono e indirizzi email:<br/><br/>
                {/*<div style={{ fontSize: "1.5rem", display: "flex", alignItems: "center" }}><PhoneIcon style={{color:"#469e51"}}/>&nbsp;<span><b>338 2382886</b></span></div>*/}
                <div style={{ marginBottom: "1.5rem", marginTop: ".5rem", fontSize: "1.5rem", display: "flex", alignItems: "center"  }}><EmailIcon style={{color:"#469e51"}}/>&nbsp;<span><b><a style={{color: "inherit"}} href="mailto:info@cinema-aurora.it">info@cinema-aurora.it</a></b></span></div>
                <h2>Ci trovi anche su:</h2>
                <FacebookIcon onClick={() => window.open('https://www.facebook.com/cinema.aurora', '_blank').focus()} style={{cursor: "pointer", marginRight:'.7rem', fontSize: "3rem", color: "#469e51"}}/>
                <InstagramIcon onClick={() => window.open('https://instagram.com/cinema.aurora?igshid=YmMyMTA2M2Y=', '_blank').focus()} style={{cursor: "pointer", marginRight:'.4rem', fontSize: "3rem", color: "#469e51"}}/>
                <TelegramIcon onClick={() => window.open('https://t.me/cinemaaurora', '_blank').focus()} style={{cursor: "pointer", marginRight:'.7rem', fontSize: "3rem", color: "#469e51"}}/>
              </Grid>
            </Grid>
            
          </Stack>
    </>
  );
}
